export default __webpack_public_path__ + "static/media/combotIcon.1b9c5671.svg";